// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3OXff","head":"Table_head__tCCJE","col":"Table_col__2rgWE"};